import { parsePtNumber, parseMoney } from './money';

/** Cofres activos que ainda precisam de depósito no ciclo actual da selfie. */
export function potCycleDepositAmount(pot) {
  if (!pot) return 0;
  const cycle = Number(pot.cycle_deposit_eur ?? 0);
  if (cycle > 0) return cycle;
  return parseMoney(pot.monthly_required);
}

export function potRemainingAmount(pot) {
  if (!pot) return 0;
  const target = parseMoney(pot.target_amount);
  const accumulated = parseMoney(pot.accumulated);
  if (Number.isFinite(Number(pot.remaining))) {
    return Math.max(0, Number(pot.remaining));
  }
  return Math.max(0, target - accumulated);
}

export function filterPotsNeedingCycleDeposit(pots = []) {
  if (!Array.isArray(pots)) return [];
  return pots.filter(
    (pot) =>
      pot.is_active !== false &&
      !pot.is_closed &&
      pot.needs_cycle_deposit !== false &&
      potCycleDepositAmount(pot) > 0,
  );
}

export function filterActivePots(pots = []) {
  if (!Array.isArray(pots)) return [];
  return pots.filter((pot) => pot.is_active !== false && !pot.is_closed);
}

export function findPotById(pots, potId) {
  if (!potId || !Array.isArray(pots)) return null;
  return pots.find((pot) => pot.id != null && String(pot.id) === String(potId)) ?? null;
}

export function decimalToPtInput(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return '';
  return n.toFixed(2).replace('.', ',');
}

/**
 * Valida um depósito com valor livre (vários depósitos por ciclo).
 * @returns {{ valid: boolean, parsed?: number, reason?: 'empty' | 'over-remaining' }}
 */
export function validatePotDepositAmount(pot, amountInput) {
  if (!pot) return { valid: false, reason: 'empty' };
  const parsed = parsePtNumber(amountInput);
  if (!parsed || parsed <= 0) return { valid: false, reason: 'empty' };

  const remaining = potRemainingAmount(pot);
  if (remaining > 0 && parsed - remaining > 0.005) {
    return { valid: false, parsed, reason: 'over-remaining' };
  }
  return { valid: true, parsed };
}

export function potRemainingAfterDeposit(pot, amountInput) {
  const remaining = potRemainingAmount(pot);
  const parsed = parsePtNumber(amountInput);
  if (!parsed || parsed <= 0) return remaining;
  return Math.max(0, remaining - parsed);
}
